import React, { useState, useContext, useEffect, useRef } from "react";
import "./productTemplate.css"
import { Context } from "../../app";
import { Mixpanel } from "../../Mixpanel";
import axios from "axios";

import { MoonLoader } from "react-spinners";
import Image from "../Image/image";
import Feature from "../feature/feature";
import Tabs from "../../components/tabs/tabs"




function ProductTemplate(props) {
    
    const [attachment, setAttachment] = useState(props.variant?props.variants[0].id:"BND")
    const [color, setColor] = useState(props.color?props.colors[0].id:"BK")
    const [reviewIndex, setReviewIndex]= useState(0)
    const [reviewsExpand, setReviewsExpand] = useState(false)
    const [loading, setLoading] = useState(false)
    const [tab, setTab] = useState("Description")
    const [attachmentPic, setAttachmentPic] = useState("products/"+props.img)
    const [benefitExpand, setBenefitExpand] = useState(false)
    const firstLoad = useRef(true)
    const shop = useContext(Context)
    // import attachmentPic from 
    useEffect(()=>{
        // const params = new Proxy(new URLSearchParams(window.location.search), {
        //     get: (searchParams, prop) => searchParams.get(prop),
        // });
        // if (params.id) {
        //     setAttachment(params.id.split("-")[2])
        //     setColor(params.id.split("-")[1])
        //     console.log("changing")
        // }
        window.scroll({
            top:0,
            left:0
        })
        // console.log(shop)
        
    },[])

    useEffect(()=>{
        setAttachmentPic("products/"+props.img)
    },[props.img])

    useEffect(()=>{
        
        if (props.variant&&props.color) {
            setAttachmentPic(`products/${props.id}-${color}-${attachment}.png`)
        }
        else if (props.color) {
            setAttachmentPic(`products/${props.id}-${color}.png`)
            
        }
        else if (props.variant) {
            // console.log("attach", props.variant)
            setAttachmentPic(`products/${props.id}-${attachment}.png`)

        }
        else {

        }
        
        
        if (!firstLoad) {
           axios({
                url:shop.url+"mixpanel",
                method:"POST",
                headers:{"Content-Type":"application/json"},
                data:{
                    event:"customizeDevice",
                    properties:{
                        page:shop.page, 
                        id:attachmentPic
                    },
                    id:shop.mpid
                }
            }).then((res)=>{
                localStorage.setItem("mp_uid", res.data.uid)
                firstLoad.current = true
            })
            .catch((e)=>console.log(e))
        }
        
    },[attachment, color])

    useEffect(()=>{
        
        if (shop.mpid) {
            // console.log("tracking")
            axios({
                url:shop.url+"mixpanel",
                method:"POST",
                headers:{"Content-Type":"application/json"},
                data:{
                    event:"Product Select",
                    properties:{
                        productID:props.id
                    },
                    id:shop.mpid
                }
            }).then((res)=>{
                // console.log(res)
            })
            .catch((e)=>{
                // console.log(e)
            })
        }
        
    }, [shop.mpid])



    

    return(
        <div className="shop-nexum">
            <div className="product-container">
                <div className="product-img">
                    
                    <Image 
                        width={props.id?.includes("BUN")||props.id?.includes("PAW")?"70%":"100%"}
                        src={attachmentPic}
                    />
                    {/* <img style={{display:`${loading?"none":"initial"}`}} onLoad={()=>setLoading(false)} src={attachmentPic} width="100%" alt="" /> */}
                    
                    
                </div>
                <div className="product-options">
                    <div className="product-header">
                        <div className="product-title">
                            <h2>{props.name}</h2>
                            <p>${props.discount} <s>${props.price}</s></p>
                        </div>
                        <p className="product-short">{props.short}</p>
                        
                    </div>
                    {
                        props.color?
                        <>
                        <div className="product-colors">
                            <p>Color:</p>
                            <div className="colors">
                                {
                                    props.colors.map((prodColor)=>{
                                        {/* console.log(prodColor.color) */}
                                        return(
                                            <div style={{border:`${color===prodColor.id?"2px solid var(--secondary4)":"none"}`}} onClick={()=>setColor(prodColor.id)} className="product-color"><div style={{background:prodColor.color}} className="color"></div></div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        </>
                        :""
                    }
                    <div className="add-cart-container">
                        <button disabled style={{backgroundColor:"var(--gray)"}} onClick={()=>{
                            shop.addCart(`${attachmentPic.split("/")[1].split(".")[0]}`, props.price, props.discount, props.name)
                            shop.setShowCart(true)
                            if (shop.mpid) {
                                axios({
                                    url:shop.url+"mixpanel",
                                    method:"POST",
                                    headers:{"Content-Type":"application/json"},
                                    data:{
                                        event:"addToCart",
                                        properties:{
                                            device:props.name,
                                            details: {
                                                attachment:attachment,
                                                color:color
                                            }
                                        },
                                        id:shop.mpid
                                    }
                                }).then((res)=>{

                                })
                                .catch((e)=>console.log(e))
                            }
                            shop.ReactPixel.trackCustom("AddToCart")
                        }} className="add--btn">Add to Cart</button>
                        {/* <a  title="Now accepting PayPal" ><img width={"100px"} src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png" border="0" alt="Now accepting PayPal"/></a> */}
                    </div>
                    <Tabs 
                        tabs={props.variant?["Description", "Features", "Select Variant"]:["Description", "Features"]}
                        tab={tab}
                        setTab={setTab}
                    />
                    <div className="product-tabs-container">
                        {
                            tab==="Description"?
                            <p className="product-info" style={{color: "var(--secondary2)"}}>
                                {props.description?props.description:props.info}
                            </p>:""
                        }
                        
                        {
                            tab==="Features"?
                            <>
                                {
                                    props.features?
                                    <div className="product-features">
                                        {/* <p>Features:</p> */}
                                        <div className="row">
                                            {
                                                props.features.map((feature)=>{
                                                    return(
                                                        <Feature 
                                                            icon={feature.icon}
                                                            name={feature.name}
                                                            details={feature.details}
                                                        />
                                                    )
                                                })
                                            }            
                                        </div>
                                    </div>:""
                                }
                            </>:""
                        }
                        {
                            tab==="Select Variant"?
                            <>
                                {
                                    props.variant?
                                    <>
                                    {/* <p style={{border:"none"}}>Choose Variant:</p> */}
                                    <div className="attachments">
                                        {
                                            props.variants.map((variant)=>{
                                                return(
                                                    <div onClick={()=>setAttachment(variant.id)}  className="attachment">
                                                        <Image 
                                                            src={props.color?`products/${props.id}-${color}-${variant.id}.png`:`products/${props.id}-${variant.id}.png`}
                                                            width="200px"
                                                            spinnerSize="50px"
                                                        />
                                                        <p style={{borderBottom: `${attachment===variant.id?"1px solid var(--secondary1)":""}`}}>{variant.name}</p>
                                                        
                                                    </div>
                                                )
                                            })
                                        }
                                    
                                    </div>
                                    </>
                                    :""
                                }
                            </>:""
                        }
                    </div>
                    
                    
                    
                    
                    
                    
                    {/* <p>*Full refunds available until 30 days after delivery (no questions asked)</p> */}
                    
                    
                    
                    <div className="shop-badges">
                        <div className="badge">
                            <i className="material-icons-outlined badge-icon">u_turn_right</i>
                            <p className="badge-text">30 day return</p>
                        </div>
                        <div className="badge">
                            <i className="material-icons-outlined badge-icon">local_shipping</i>
                            <p className="badge-text">Free Shipping</p>
                        </div>
                        <div className="badge">
                            <i className="material-icons-outlined badge-icon">lock</i>
                            <p className="badge-text">Secure Checkout</p>
                        </div>
                    </div>
                
                </div>
            </div>
            <div className="product-sections">
                {
                    props.benefits?
                    <div onClick={()=>setBenefitExpand(!benefitExpand)} className="why-busy product-section">
                        <h1>Benefits <i className="material-icons-outlined">{benefitExpand?"expand_less":"expand_more"}</i></h1>
                        {
                            props.benefits.map((benefit)=>{
                                return(
                                    <div className="benefit">
                                        <i className="material-icons-outlined">{benefit.icon}</i>
                                        <p>{benefit.text}</p>
                                    </div>
                                )
                            })
                        }
                    </div>:""
                }
                {
                    props.reviews?
                    <div style={{maxHeight:`${reviewsExpand?"700px":"80px"}`}} className="reviews product-section">
                        <h1 onClick={()=>setReviewsExpand(!reviewsExpand)}>Beta Test Reviews <i className="material-icons-outlined">{reviewsExpand?"expand_less":"expand_more"}</i></h1>
                        <div className="reviews-container">
                            <button onClick={()=>setReviewIndex(reviewIndex===0?props.reviews.length-1:0)} className="btn--flat"><i className="material-icons">arrow_back_ios</i></button>
                            <div class="review">
                                <p>"{props.reviews[reviewIndex]?.text}"</p>

                            </div>
                            <button onClick={()=>setReviewIndex(reviewIndex===props.reviews.length-1?0:reviewIndex+1)} className="btn--flat"><i className="material-icons">arrow_forward_ios</i></button>
                        </div>
                        
                    </div>
                    :""
                }
                {/* <div className="how-it-works product-section">
                    <h1>How It Works <i className="material-icons-outlined">expand_more</i></h1>
                </div> */}
            </div>
            
        </div>
    )
}

export default ProductTemplate